export default "__VITE_ASSET__CASiY7aX__"